export const districts: string[] = [
  "Quận 1",
  "Quận 2",
  "Quận 3",
  "Quận 4",
  "Quận 5",
  "Quận 6",
  "Quận 7",
  "Quận 8",
  "Quận 9",
  "Quận 10",
  "Quận 11",
  "Quận 12",
  "Quận Tân Bình",
  "Quận Tân Phú",
  "Quận Phú Nhuận",
  "Quận Bình Thạnh",
  "Quận Gò Vấp",
  "Thủ Đức",
];

export const districtEnMap: Record<string, string> = {
  "Quận 1": "District 1",
  "Quận 2": "District 2",
  "Quận 3": "District 3",
  "Quận 4": "District 4",
  "Quận 5": "District 5",
  "Quận 6": "District 6",
  "Quận 7": "District 7",
  "Quận 8": "District 8",
  "Quận 9": "District 9",
  "Quận 10": "District 10",
  "Quận 11": "District 11",
  "Quận 12": "District 12",
  "Quận Tân Bình": "Tan Binh District",
  "Quận Tân Phú": "Tan Phu District",
  "Quận Phú Nhuận": "Phu Nhuan District",
  "Quận Bình Thạnh": "Binh Thanh District",
  "Quận Gò Vấp": "Go Vap District",
  "Thủ Đức": "Thu Duc City",
};
